<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="reports"
      :items-per-page="10"
      :sort-by="['name']"
    >
      <template v-slot:item.action="{ item }">
        <action-slot-component
          :item="item"
          route-name="reports.export"
          :route-params="{ type: item.type }"
          @show="$emit('show', item)"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ActionSlotComponent from '@/modules/_global/_components/ActionSlotComponent.vue';

export default {
  name: 'ReportList',
  components: { ActionSlotComponent },

  props: {
    reports: {
      type: Array,
      required: true
    }
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          // sortable: true,
          value: 'id'
        },
        {
          text: this.$t('REPORTS.ITEM'),
          sortable: true,
          value: 'name'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    }
  }
};
</script>
